import React, { useEffect, useState } from "react";
import api from "../services/api";

function Industries() {

const [name,setName] = useState("");
const [description,setDescription] = useState("");
const [status,setStatus] = useState("active");

const [industries,setIndustries] = useState([]);
const [editingId,setEditingId] = useState(null);

useEffect(()=>{
loadIndustries();
},[]);


/* ---------- LOAD INDUSTRIES ---------- */

const loadIndustries = async ()=>{

try{

const res = await api.get("/industries");

setIndustries(res.data.data || []);

}catch(err){

console.log(err);

}

};


/* ---------- SAVE INDUSTRY ---------- */

const saveIndustry = async ()=>{

if(!name){

alert("Enter industry name");

return;

}

try{

if(editingId){

await api.put(`/industries/${editingId}`,{
name,
description,
status
});

alert("Industry updated");

}else{

await api.post("/industries",{
name,
description,
status
});

alert("Industry created");

}

setName("");
setDescription("");
setStatus("active");
setEditingId(null);

loadIndustries();

}catch(err){

alert("Operation failed");

}

};


/* ---------- EDIT ---------- */

const editIndustry = (industry)=>{

setName(industry.name);
setDescription(industry.description || "");
setStatus(industry.status || "active");
setEditingId(industry.id);

window.scrollTo({top:0,behavior:"smooth"});

};


/* ---------- DELETE ---------- */

const deleteIndustry = async (id)=>{

const confirmDelete = window.confirm("Delete this industry?");

if(!confirmDelete) return;

try{

await api.delete(`/industries/${id}`);

loadIndustries();

}catch(err){

alert("Active industries cannot be deleted. Please deactivate first.");

}

};


return(

<div style={{padding:"30px"}}>

<h2 style={{marginBottom:"25px"}}>Industries</h2>


{/* CREATE / EDIT FORM */}

<div style={card}>

<h3 style={{marginBottom:"15px"}}>
{editingId ? "Edit Industry" : "Create Industry"}
</h3>

<div style={{display:"flex",flexDirection:"column",gap:"10px",maxWidth:"450px"}}>

<input
placeholder="Industry Name"
value={name}
onChange={(e)=>setName(e.target.value)}
style={input}
/>

<input
placeholder="Description"
value={description}
onChange={(e)=>setDescription(e.target.value)}
style={input}
/>

{/* <input

value={name}
onChange={(e)=>setStatus(e.target.value)}
style={input}

/> */}


{/* STATUS DROPDOWN */}
<select

value={status}
onChange={(e)=>setStatus(e.target.value)}
style={input}
>

<option value="active">Active</option>
<option value="inactive">Inactive</option>

</select>


<button
style={primaryBtn}
onClick={saveIndustry}
>
{editingId ? "Update Industry" : "Add Industry"}
</button>

</div>

</div>


{/* INDUSTRIES LIST */}

<div style={card}>

<h3 style={{marginBottom:"20px"}}>Industries List</h3>

<table style={table}>

<thead style={tableHeader}>

<tr>

<th>Industry Name</th>
<th>Description</th>
<th>Status</th>
<th>Actions</th>

</tr>

</thead>

<tbody>

{industries.map(industry=>(

<tr key={industry.id} style={row}>

<td>{industry.name}</td>

<td>{industry.description}</td>

<td>

<span style={{
padding:"4px 10px",
borderRadius:"4px",
background:industry.status==="active" ? "#2ecc71" : "#e74c3c",
color:"#fff",
fontSize:"12px"
}}>
{industry.status}
</span>

</td>

<td>

<button
style={editBtn}
onClick={()=>editIndustry(industry)}
>
Edit
</button>

<button
style={deleteBtn}
onClick={()=>deleteIndustry(industry.id)}
>
Delete
</button>

</td>

</tr>

))}

</tbody>

</table>

</div>

</div>

)

}


/* ---------- UI STYLES ---------- */



const label = {
fontSize:"13px",
color:"#666",
fontWeight:"500"
};

const statusSelect = {
padding:"10px",
border:"2px solid",
borderRadius:"6px",
fontSize:"14px",
fontWeight:"500",
outline:"none",
cursor:"pointer",
transition:"all 0.2s ease"
};

const card = {

background:"#fff",
padding:"25px",
borderRadius:"8px",
boxShadow:"0 2px 10px rgba(0,0,0,0.08)",
marginBottom:"30px"

};

const input = {

padding:"10px",
border:"1px solid #ddd",
borderRadius:"6px",
fontSize:"14px"

};

const primaryBtn = {

background:"#2c3e50",
color:"#fff",
border:"none",
padding:"10px",
borderRadius:"6px",
cursor:"pointer",
width:"160px"

};

const editBtn = {

background:"#f39c12",
border:"none",
color:"#fff",
padding:"6px 12px",
marginRight:"8px",
borderRadius:"4px",
cursor:"pointer"

};

const deleteBtn = {

background:"#e74c3c",
border:"none",
color:"#fff",
padding:"6px 12px",
borderRadius:"4px",
cursor:"pointer"

};

const table = {

width:"100%",
borderCollapse:"collapse"

};

const tableHeader = {

background:"#f5f6fa",
textAlign:"left"

};

const row = {

borderBottom:"1px solid #eee"

};

export default Industries;
